import React from "react";
import { LocationIcon } from "../../../../helper/HwIcon";

export const HotelLocation = ({ data }) => {
  return (
    <div id="hotel_location" className="hw-hotel--singleListSection">
      <h2 className="h4 mb-20">Location</h2>
      <div className="hw-section--box">
        <div>
          <div className="hw-fontBold hw-gray-900 hw-text20 mb-1">
            {data?.hotelInfo?.name}
          </div>
          <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
            <LocationIcon />
            {data?.hotelInfo?.address}
          </div>
        </div>
        <div className="map-section">
          <iframe
            height="450"
            style={{ border: 0, width: "100%" }}
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${data?.hotelInfo?.lat},${data?.hotelInfo?.lang}&z=15&output=embed`}
          ></iframe>
        </div>
      </div>
    </div>
  );
};
